// import React, { useState, useEffect } from "react";
// import { useSelector } from "react-redux";
// import { BookOpen, Loader2, Search, Plus, Edit3, Trash2, Play, ChevronLeft, ChevronRight, Grid, List, SortAsc, SortDesc, Download, Copy, FileText, Brain, Video, } from "lucide-react";
// import axiosInstance from "@/axios";
// import { FaBookReader } from "react-icons/fa";
// import { toast } from "react-toastify";

// const ExamAndQuiz = () => {
//     const { courses } = useSelector((state) => state?.course || {});
//     const allCourses = courses?.all?.courses || [];

//     // Original state
//     const [selectedCourse, setSelectedCourse] = useState(null);
//     const [templates, setTemplates] = useState([]);
//     const [selectedTemplate, setSelectedTemplate] = useState(null);
//     const [messages, setMessages] = useState([]);
//     const [isLoading, setIsLoading] = useState(false);
//     const [editingTemplate, setEditingTemplate] = useState(null);
//     const [showForm, setShowForm] = useState(false);
//     const [newTemplate, setNewTemplate] = useState({
//         name: "",
//         difficulty: "easy",
//         type: "quiz",
//         topics: "",
//         questionCount: 5,
//     });

//     // New state for filters and pagination
//     const [searchTerm, setSearchTerm] = useState("");
//     const [difficultyFilter, setDifficultyFilter] = useState("all");
//     const [typeFilter, setTypeFilter] = useState("all");
//     const [sortBy, setSortBy] = useState("name");
//     const [sortOrder, setSortOrder] = useState("asc");
//     const [viewMode, setViewMode] = useState("grid");
//     const [currentPage, setCurrentPage] = useState(1);
//     const [templatesPerPage] = useState(6);

//     // Course filters
//     const [courseSearchTerm, setCourseSearchTerm] = useState("");
//     const [coursePage, setCoursePage] = useState(1);
//     const [coursesPerPage] = useState(6);

//     // 🔹 Fetch templates when course changes
//     useEffect(() => {
//         if (selectedCourse) {
//             fetchTemplates(selectedCourse.ID);
//             setCurrentPage(1); // Reset to first page when course changes
//         }
//     }, [selectedCourse]);

//     const fetchTemplates = async (courseId) => {
//         try {
//             const response = await axiosInstance.get(`/templates/${courseId}`);
//             if (response.status === 200) {
//                 setTemplates(response?.data?.data || []);
//             }

//         } catch (error) {
//             toast.error("Error fetching templates:", error);
//         }
//     };

//     // Filter and sort templates
//     const filteredTemplates = templates.filter(template => {
//         const matchesSearch = template.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//             template.topics.some(topic => topic.toLowerCase().includes(searchTerm.toLowerCase()));
//         const matchesDifficulty = difficultyFilter === "all" || template.difficulty === difficultyFilter;
//         const matchesType = typeFilter === "all" || template.type === typeFilter;

//         return matchesSearch && matchesDifficulty && matchesType;
//     }).sort((a, b) => {
//         let comparison = 0;
//         switch (sortBy) {
//             case "name":
//                 comparison = a.name.localeCompare(b.name);
//                 break;
//             case "difficulty":
//                 const difficultyOrder = { easy: 1, medium: 2, hard: 3 };
//                 comparison = difficultyOrder[a.difficulty] - difficultyOrder[b.difficulty];
//                 break;
//             case "type":
//                 comparison = a.type.localeCompare(b.type);
//                 break;
//             case "questions":
//                 comparison = a.questionCount - b.questionCount;
//                 break;
//             case "date":
//                 comparison = new Date(a.createdAt) - new Date(b.createdAt);
//                 break;
//             default:
//                 comparison = 0;
//         }
//         return sortOrder === "asc" ? comparison : -comparison;
//     });
//     // Filter courses
//     const filteredCourses = allCourses.filter(course =>
//         course.CourseName.toLowerCase().includes(courseSearchTerm.toLowerCase())
//     );

//     // Pagination logic for templates
//     const totalTemplatePages = Math.ceil(filteredTemplates.length / templatesPerPage);
//     const startTemplateIndex = (currentPage - 1) * templatesPerPage;
//     const currentTemplates = filteredTemplates.slice(startTemplateIndex, startTemplateIndex + templatesPerPage);

//     // Pagination logic for courses
//     const totalCoursePages = Math.ceil(filteredCourses.length / coursesPerPage);
//     const startCourseIndex = (coursePage - 1) * coursesPerPage;
//     const currentCourses = filteredCourses.slice(startCourseIndex, startCourseIndex + coursesPerPage);

//     // Save template (Add / Update)
//     const handleSaveTemplate = async () => {
//         if (!selectedCourse) return;

//         try {
//             const url = editingTemplate
//                 ? `/templates/update/${editingTemplate.id}`
//                 : `/templates/create`;

//             const topicsArray = newTemplate.topics
//                 .split(",")
//                 .map((t) => t.trim())
//                 .filter((t) => t);

//             const payload = {
//                 course_id: selectedCourse.ID,
//                 name: newTemplate.name,
//                 difficulty: newTemplate.difficulty,
//                 type: newTemplate.type,
//                 question_count: parseInt(newTemplate.questionCount, 10),
//                 topics: topicsArray,
//             };

//             const response = editingTemplate
//                 ? await axiosInstance.post(url, payload)
//                 : await axiosInstance.post(url, payload);

//             if (response.status === 200) {
//                 toast.success(response?.data?.message || "Template saved successfully");
//                 fetchTemplates(selectedCourse.ID);
//                 setEditingTemplate(null);
//                 setShowForm(false);
//                 setNewTemplate({
//                     name: "",
//                     difficulty: "easy",
//                     type: "quiz",
//                     topics: "",
//                     questionCount: 5,
//                 });
//             }
//         } catch (error) {
//             toast.error("Error saving template:", error);
//         }
//     };

//     const handleDeleteTemplate = async (templateId) => {
//         try {
//             const response = await axiosInstance.delete(`/templates/delete/${templateId}`);
//             toast.success(response?.data?.message || "Template deleted successfully..")
//             fetchTemplates(selectedCourse.ID);

//         } catch (error) {
//             toast.error("Error deleting template:", error);
//         }
//     };

//     const handleTemplateClick = async (course, template) => {
//         setSelectedTemplate(template);
//         setIsLoading(true);

//         const prompt = buildPrompt(course.CourseName, template);
//         const courseId =course.ID;
//         const numberOfQuestions = template.questionCount;
//         const questionType = template.type
//         try {
//             const response = await axiosInstance.post("/templates/generate-quiz", {
//                 courseId,
//                 prompt,
//                 numberOfQuestions,
//                 questionType
//         });
//             setMessages((prev) => [
//                 ...prev,
//                 { role: "assistant", content: response.data },
//             ]);
//         } catch (err) {
//             toast.error("Error generating quiz:", err);
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     const buildPrompt = (courseName, template) => {
//         return `Generate a ${template.type} for the course "${courseName}" with ${template.questionCount} questions on topics: ${template.topics.join(", ")}. Difficulty: ${template.difficulty}`;
//     };

//     const getDifficultyColor = (difficulty) => {
//         switch (difficulty) {
//             case "easy": return "bg-green-100 text-green-800";
//             case "medium": return "bg-yellow-100 text-yellow-800";
//             case "hard": return "bg-red-100 text-red-800";
//             default: return "bg-gray-100 text-gray-800";
//         }
//     };

//     const getTypeIcon = (type) => {
//         switch (type) {
//             case "multiple_choice": return <Brain className="w-6 h-6 text-[#264b82]" />;
//             case "true_false": return <FaBookReader className="w-6 h-6 text-[#264b82]" />;
//             case "short_answer": return <BookOpen className="w-6 h-6 text-[#264b82]" />;
//             default: return <BookOpen className="w-6 h-6 text-[#264b82]" />;
//         }
//     };

//     return (
//         <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
//             <div className="!container mx-auto p-6">
//                 {/* Header */}

//                 <div className="dashboard-container-new !mb-6">
//                     <p>Exam & Quiz generate tempalte</p>
//                 </div>

//                 <div className="grid grid-cols-1 xl:grid-cols-3 gap-8">
//                     {/* Left - Courses Section */}
//                     <div className="xl:col-span-1">
//                         <div className="bg-white rounded-2xl shadow-lg p-6 sticky top-6">
//                             <div className="flex items-center justify-between mb-6">
//                                 <h2 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
//                                     <BookOpen className="w-6 h-6 text-[#264b82]" />
//                                     Courses
//                                 </h2>
//                                 <span className="bg-[#264b82] text-white px-3 py-1 rounded-full text-sm font-medium">
//                                     {filteredCourses.length}
//                                 </span>
//                             </div>

//                             {/* Course Search */}
//                             <div className="relative mb-4">
//                                 <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
//                                 <input
//                                     type="text"
//                                     placeholder="Search courses..."
//                                     value={courseSearchTerm}
//                                     onChange={(e) => {
//                                         setCourseSearchTerm(e.target.value);
//                                         setCoursePage(1);
//                                     }}
//                                     className="w-full pl-10 pr-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-[#264b82] focus:border-[#264b82] transition-all"
//                                 />
//                             </div>

//                             {/* Course List */}
//                             <div className="space-y-3 max-h-96 overflow-y-auto">
//                                 {currentCourses.map((course) => (
//                                     <div
//                                         key={course.ID}
//                                         className={`p-4 rounded-xl border-2 cursor-pointer transition-all duration-200 hover:scale-105 hover:shadow-md ${selectedCourse?.ID === course.ID
//                                             ? "bg-[#264b82] text-white border-[#264b82] shadow-lg"
//                                             : "bg-white text-gray-700 border-gray-200 hover:border-[#264b82]"
//                                             }`}
//                                         onClick={() => setSelectedCourse(course)}
//                                     >
//                                         <h3 className="font-semibold text-lg mb-1">{course.CourseName}</h3>
//                                         <span className={`text-sm ${selectedCourse?.ID === course.ID ? "text-blue-100" : "text-gray-500"
//                                             }`}>
//                                             Click to explore →
//                                         </span>
//                                     </div>
//                                 ))}
//                             </div>

//                             {/* Course Pagination */}
//                             {totalCoursePages > 1 && (
//                                 <div className="flex justify-center items-center gap-2 mt-4 pt-4 border-t border-gray-200">
//                                     <button
//                                         onClick={() => setCoursePage(prev => Math.max(prev - 1, 1))}
//                                         disabled={coursePage === 1}
//                                         className="p-2 rounded-lg border border-gray-200 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
//                                     >
//                                         <ChevronLeft className="w-4 h-4" />
//                                     </button>
//                                     <span className="px-3 py-1 text-sm text-gray-600">
//                                         {coursePage} of {totalCoursePages}
//                                     </span>
//                                     <button
//                                         onClick={() => setCoursePage(prev => Math.min(prev + 1, totalCoursePages))}
//                                         disabled={coursePage === totalCoursePages}
//                                         className="p-2 rounded-lg border border-gray-200 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
//                                     >
//                                         <ChevronRight className="w-4 h-4" />
//                                     </button>
//                                 </div>
//                             )}
//                         </div>
//                     </div>

//                     {/* Right - Templates Section */}
//                     <div className="xl:col-span-2">
//                         {selectedCourse ? (
//                             <div className="space-y-6">
//                                 {/* Templates Header */}
//                                 <div className="bg-white rounded-2xl shadow-lg p-6">
//                                     <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
//                                         <h2 className="text-2xl font-bold text-gray-900">
//                                             Templates for {selectedCourse.CourseName}
//                                         </h2>
//                                         <button
//                                             onClick={() => setShowForm(!showForm)}
//                                             className="bg-[#264b82] text-white px-4 py-2 rounded-lg hover:shadow-lg transition-all duration-200 flex items-center gap-2"
//                                         >
//                                             <Plus className="w-4 h-4" />
//                                             Add Template
//                                         </button>
//                                     </div>

//                                     {/* Filters and Search */}
//                                     <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
//                                         <div className="relative">
//                                             <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
//                                             <input
//                                                 type="text"
//                                                 placeholder="Search templates..."
//                                                 value={searchTerm}
//                                                 onChange={(e) => {
//                                                     setSearchTerm(e.target.value);
//                                                     setCurrentPage(1);
//                                                 }}
//                                                 className="w-full pl-10 pr-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-[#264b82] focus:border-[#264b82] transition-all"
//                                             />
//                                         </div>

//                                         <select
//                                             value={difficultyFilter}
//                                             onChange={(e) => {
//                                                 setDifficultyFilter(e.target.value);
//                                                 setCurrentPage(1);
//                                             }}
//                                             className="border border-gray-200 rounded-lg px-3 py-2 focus:ring-2 focus:ring-[#264b82] focus:border-[#264b82] transition-all"
//                                         >
//                                             <option value="all">All Difficulties</option>
//                                             <option value="easy">Easy</option>
//                                             <option value="medium">Medium</option>
//                                             <option value="hard">Hard</option>
//                                         </select>

//                                         <select
//                                             value={typeFilter}
//                                             onChange={(e) => {
//                                                 setTypeFilter(e.target.value);
//                                                 setCurrentPage(1);
//                                             }}
//                                             className="border border-gray-200 rounded-lg px-3 py-2 focus:ring-2 focus:ring-[#264b82] focus:border-[#264b82] transition-all"
//                                         >
//                                             <option value="all">All Types</option>
//                                             <option value="quiz">Quiz</option>
//                                             <option value="exam">Exam</option>
//                                             <option value="flashcards">Flashcards</option>
//                                             <option value="webinar">Webinar</option>
//                                         </select>

//                                         <div className="flex gap-2">
//                                             <select
//                                                 value={sortBy}
//                                                 onChange={(e) => setSortBy(e.target.value)}
//                                                 className="flex-1 border border-gray-200 rounded-lg px-3 py-2 focus:ring-2 focus:ring-[#264b82] focus:border-[#264b82] transition-all"
//                                             >
//                                                 <option value="name">Sort by Name</option>
//                                                 <option value="difficulty">Sort by Difficulty</option>
//                                                 <option value="type">Sort by Type</option>
//                                                 <option value="questions">Sort by Questions</option>
//                                                 <option value="date">Sort by Date</option>
//                                             </select>
//                                             <button
//                                                 onClick={() => setSortOrder(sortOrder === "asc" ? "desc" : "asc")}
//                                                 className="p-2 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
//                                             >
//                                                 {sortOrder === "asc" ? <SortAsc className="w-4 h-4" /> : <SortDesc className="w-4 h-4" />}
//                                             </button>
//                                         </div>
//                                     </div>

//                                     {/* View Toggle */}
//                                     <div className="flex justify-between items-center">
//                                         <span className="text-sm text-gray-600">
//                                             Showing {currentTemplates.length} of {filteredTemplates.length} templates
//                                         </span>
//                                         <div className="flex gap-1 bg-gray-100 rounded-lg p-1">
//                                             <button
//                                                 onClick={() => setViewMode("grid")}
//                                                 className={`p-2 rounded-md transition-colors ${viewMode === "grid" ? "bg-white shadow-sm" : "hover:bg-gray-200"
//                                                     }`}
//                                             >
//                                                 <Grid className="w-4 h-4" />
//                                             </button>
//                                             <button
//                                                 onClick={() => setViewMode("list")}
//                                                 className={`p-2 rounded-md transition-colors ${viewMode === "list" ? "bg-white shadow-sm" : "hover:bg-gray-200"
//                                                     }`}
//                                             >
//                                                 <List className="w-4 h-4" />
//                                             </button>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 {/* Add/Edit Template Form */}
//                                 {showForm && (
//                                     <div className="bg-white rounded-2xl shadow-lg p-6">
//                                         <h3 className="text-xl font-bold text-gray-900 mb-4">
//                                             {editingTemplate ? "Edit Template" : "Add New Template"}
//                                         </h3>
//                                         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                                             <input
//                                                 type="text"
//                                                 placeholder="Template Name"
//                                                 value={newTemplate.name}
//                                                 onChange={(e) =>
//                                                     setNewTemplate({ ...newTemplate, name: e.target.value })
//                                                 }
//                                                 className="border border-gray-200 rounded-lg px-3 py-2 focus:ring-2 focus:ring-[#264b82] focus:border-[#264b82] transition-all"
//                                             />
//                                             <input
//                                                 type="text"
//                                                 placeholder="Topics (comma separated)"
//                                                 value={newTemplate.topics}
//                                                 onChange={(e) =>
//                                                     setNewTemplate({
//                                                         ...newTemplate,
//                                                         topics: e.target.value,
//                                                     })
//                                                 }
//                                                 className="border border-gray-200 rounded-lg px-3 py-2 focus:ring-2 focus:ring-[#264b82] focus:border-[#264b82] transition-all"
//                                             />
//                                             <input
//                                                 type="number"
//                                                 placeholder="Number of Questions"
//                                                 value={newTemplate.questionCount}
//                                                 onChange={(e) =>
//                                                     setNewTemplate({
//                                                         ...newTemplate,
//                                                         questionCount: e.target.value,
//                                                     })
//                                                 }
//                                                 className="border border-gray-200 rounded-lg px-3 py-2 focus:ring-2 focus:ring-[#264b82] focus:border-[#264b82] transition-all"
//                                             />
//                                             <select
//                                                 value={newTemplate.difficulty}
//                                                 onChange={(e) =>
//                                                     setNewTemplate({
//                                                         ...newTemplate,
//                                                         difficulty: e.target.value,
//                                                     })
//                                                 }
//                                                 className="border border-gray-200 rounded-lg px-3 py-2 focus:ring-2 focus:ring-[#264b82] focus:border-[#264b82] transition-all"
//                                             >
//                                                 <option value="easy">Easy</option>
//                                                 <option value="medium">Medium</option>
//                                                 <option value="hard">Hard</option>
//                                             </select>
//                                             <select
//                                                 value={newTemplate.type}
//                                                 onChange={(e) =>
//                                                     setNewTemplate({
//                                                         ...newTemplate,
//                                                         type: e.target.value,
//                                                     })
//                                                 }
//                                                 className="border border-gray-200 rounded-lg px-3 py-2 focus:ring-2 focus:ring-[#264b82] focus:border-[#264b82] transition-all md:col-span-2"
//                                             >
//                                                 <option value="multiple_choice">multiple choice</option>
//                                                 <option value="true_false">true/false</option>
//                                                 <option value="short_answer">Fill in the Blank</option>

//                                             </select>
//                                         </div>

//                                         <div className="flex gap-3 mt-6">
//                                             <button
//                                                 onClick={handleSaveTemplate}
//                                                 className="bg-[#264b82] text-white px-6 py-2 rounded-lg hover:shadow-lg transition-all duration-200 flex items-center gap-2"
//                                             >
//                                                 {editingTemplate ? "Update Template" : "Add Template"}
//                                             </button>
//                                             <button
//                                                 onClick={() => {
//                                                     setShowForm(false);
//                                                     setEditingTemplate(null);
//                                                     setNewTemplate({
//                                                         name: "",
//                                                         difficulty: "easy",
//                                                         type: "quiz",
//                                                         topics: "",
//                                                         questionCount: 5,
//                                                     });
//                                                 }}
//                                                 className="bg-gray-500 text-white px-6 py-2 rounded-lg hover:bg-gray-600 transition-colors flex items-center gap-2"
//                                             >
//                                                 Cancel
//                                             </button>
//                                         </div>
//                                     </div>
//                                 )}

//                                 {/* Templates Grid/List */}
//                                 <div className="bg-white rounded-2xl shadow-lg p-6">
//                                     {currentTemplates.length > 0 ? (
//                                         <>
//                                             <div className={
//                                                 viewMode === "grid"
//                                                     ? "grid grid-cols-1 md:grid-cols-2 gap-4"
//                                                     : "space-y-4"
//                                             }>
//                                                 {currentTemplates.map((template) => (
//                                                     <div
//                                                         key={template.id}
//                                                         className={`border-2 rounded-xl p-4 transition-all duration-200 hover:shadow-lg ${selectedTemplate?.id === template.id
//                                                             ? "border-[#264b82] bg-blue-50"
//                                                             : "border-gray-200 hover:border-gray-300"
//                                                             } ${viewMode === "list" ? "flex items-center justify-between" : ""}`}
//                                                     >
//                                                         <div className={viewMode === "list" ? "flex-1" : ""}>
//                                                             <div className="flex items-center gap-2 mb-2">
//                                                                 <span className="text-2xl">{getTypeIcon(template.type)}</span>
//                                                                 <h3 className="font-semibold text-lg text-gray-900">{template.name}</h3>
//                                                             </div>

//                                                             <div className={`${viewMode === "list" ? "flex gap-4 text-sm" : "space-y-2 text-sm"}`}>
//                                                                 <div className="flex items-center gap-4">
//                                                                     <span className={`px-2 py-1 rounded-full text-xs font-medium ${getDifficultyColor(template.difficulty)}`}>
//                                                                         {template.difficulty}
//                                                                     </span>
//                                                                     <span className="text-gray-600">Type: {template.type}</span>
//                                                                 </div>
//                                                                 <div className="text-gray-600">
//                                                                     Topics: {Array.isArray(template.topics) ? template.topics.join(", ") : template.topics}
//                                                                 </div>
//                                                                 <div className="text-gray-600">Questions: {template.questionCount}</div>
//                                                             </div>
//                                                         </div>

//                                                         <div className={`${viewMode === "list" ? "flex" : "flex mt-4"} gap-2`}>
//                                                             <button
//                                                                 onClick={() => handleTemplateClick(selectedCourse, template)}
//                                                                 className="bg-[#264b82] text-white px-3 py-2 rounded-lg hover:shadow-md transition-all duration-200 flex items-center gap-1"
//                                                             >
//                                                                 <Play className="w-4 h-4" />
//                                                                 Generate
//                                                             </button>
//                                                             <button
//                                                                 onClick={() => {
//                                                                     setEditingTemplate(template);
//                                                                     setNewTemplate({
//                                                                         ...template,
//                                                                         topics: Array.isArray(template.topics) ? template.topics.join(", ") : template.topics,
//                                                                     });
//                                                                     setShowForm(true);
//                                                                 }}
//                                                                 className="bg-white text-[#264b82] border border-[#264b82] px-3 py-2 rounded-lg hover:bg-[#264b82] hover:text-white transition-all duration-200 flex items-center gap-1"
//                                                             >
//                                                                 <Edit3 className="w-4 h-4" />
//                                                                 Edit
//                                                             </button>
//                                                             <button
//                                                                 onClick={() => handleDeleteTemplate(template.id)}
//                                                                 className="bg-white text-red-600 border border-red-600 px-3 py-2 rounded-lg hover:bg-red-600 hover:text-white transition-all duration-200 flex items-center gap-1"
//                                                             >
//                                                                 <Trash2 className="w-4 h-4" />
//                                                                 Delete
//                                                             </button>
//                                                         </div>
//                                                     </div>
//                                                 ))}
//                                             </div>

//                                             {/* Template Pagination */}
//                                             {totalTemplatePages > 1 && (
//                                                 <div className="flex justify-center items-center gap-2 mt-6 pt-6 border-t border-gray-200">
//                                                     <button
//                                                         onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
//                                                         disabled={currentPage === 1}
//                                                         className="p-2 rounded-lg border border-gray-200 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50 transition-colors"
//                                                     >
//                                                         <ChevronLeft className="w-4 h-4" />
//                                                     </button>

//                                                     <div className="flex gap-1">
//                                                         {Array.from({ length: Math.min(5, totalTemplatePages) }, (_, i) => {
//                                                             let pageNum;
//                                                             if (totalTemplatePages <= 5) {
//                                                                 pageNum = i + 1;
//                                                             } else {
//                                                                 if (currentPage <= 3) {
//                                                                     pageNum = i + 1;
//                                                                 } else if (currentPage >= totalTemplatePages - 2) {
//                                                                     pageNum = totalTemplatePages - 4 + i;
//                                                                 } else {
//                                                                     pageNum = currentPage - 2 + i;
//                                                                 }
//                                                             }

//                                                             return (
//                                                                 <button
//                                                                     key={pageNum}
//                                                                     onClick={() => setCurrentPage(pageNum)}
//                                                                     className={`px-3 py-2 rounded-lg transition-colors ${currentPage === pageNum
//                                                                         ? "bg-[#264b82] text-white"
//                                                                         : "border border-gray-200 hover:bg-gray-50"
//                                                                         }`}
//                                                                 >
//                                                                     {pageNum}
//                                                                 </button>
//                                                             );
//                                                         })}
//                                                     </div>

//                                                     <button
//                                                         onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalTemplatePages))}
//                                                         disabled={currentPage === totalTemplatePages}
//                                                         className="p-2 rounded-lg border border-gray-200 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50 transition-colors"
//                                                     >
//                                                         <ChevronRight className="w-4 h-4" />
//                                                     </button>
//                                                 </div>
//                                             )}
//                                         </>
//                                     ) : (
//                                         <div className="text-center py-12">
//                                             <h3 className="text-xl font-semibold text-gray-900 mb-2">No templates found</h3>
//                                             <p className="text-gray-600 mb-4">
//                                                 {searchTerm || difficultyFilter !== "all" || typeFilter !== "all"
//                                                     ? "Try adjusting your filters or search terms"
//                                                     : "Create your first template to get started"}
//                                             </p>
//                                             {!searchTerm && difficultyFilter === "all" && typeFilter === "all" && (
//                                                 <button
//                                                     onClick={() => setShowForm(true)}
//                                                     className="bg-[#264b82] text-white px-6 py-3 rounded-lg hover:shadow-lg transition-all duration-200 flex items-center gap-2 mx-auto"
//                                                 >
//                                                     <Plus className="w-4 h-4" />
//                                                     Create First Template
//                                                 </button>
//                                             )}
//                                         </div>
//                                     )}
//                                 </div>

//                                 {/* Generated Output */}
//                                 <div className="bg-white rounded-2xl shadow-lg p-6">
//                                     <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-2">
//                                         Generated Output
//                                     </h3>
//                                     <div className="bg-gray-50 rounded-xl p-6 min-h-[300px]">
//                                         {isLoading ? (
//                                             <div className="flex flex-col items-center justify-center h-full space-y-4">
//                                                 <Loader2 className="animate-spin w-8 h-8 text-[#264b82]" />
//                                                 <p className="text-gray-600">Generating your quiz content...</p>
//                                                 <div className="w-64 bg-gray-200 rounded-full h-2">
//                                                     <div className="bg-[#264b82] h-2 rounded-full animate-pulse" style={{ width: '60%' }}></div>
//                                                 </div>
//                                             </div>
//                                         ) : messages.length > 0 ? (
//                                             <div className="space-y-4">
//                                                 <div className="bg-gray-900 text-green-400 p-4 rounded-lg font-mono text-sm max-h-96 overflow-y-auto">
//                                                     <pre className="whitespace-pre-wrap">
//                                                         {JSON.stringify(messages[messages.length - 1].content, null, 2)}
//                                                     </pre>
//                                                 </div>
//                                                 <div className="flex gap-2">
//                                                     <button className="bg-[#264b82] text-white px-4 py-2 rounded-lg hover:bg-[#1e3a6b] transition-colors flex items-center gap-2">
//                                                         <Download className="w-4 h-4" />
//                                                         Download
//                                                     </button>
//                                                     <button className="bg-gray-600 text-white px-4 py-2 rounded-lg hover:bg-gray-700 transition-colors flex items-center gap-2">
//                                                         <Copy className="w-4 h-4" />
//                                                         Copy to Clipboard
//                                                     </button>
//                                                     <button className="bg-[#264b82] text-white px-4 py-2 rounded-lg hover:bg-[#1e3a6b] transition-colors flex items-center gap-2">
//                                                         <FileText className="w-4 h-4" />
//                                                         Export as PDF
//                                                     </button>
//                                                 </div>
//                                             </div>
//                                         ) : (
//                                             <div className="flex flex-col items-center justify-center h-full text-center">
//                                                 <h4 className="text-xl font-semibold text-gray-900 mb-2">Ready to Generate</h4>
//                                                 <p className="text-gray-600 max-w-md">
//                                                     Select a template and click "Generate" to create your quiz or exam content using AI
//                                                 </p>
//                                             </div>
//                                         )}
//                                     </div>
//                                 </div>
//                             </div>
//                         ) : (
//                             <div className="bg-white rounded-2xl shadow-lg p-12 text-center">
//                                 <h3 className="text-3xl font-bold text-gray-900 mb-4">Select a Course</h3>
//                                 <p className="text-gray-600 text-lg max-w-md mx-auto">
//                                     Choose a course from the left panel to view and manage its templates, or create new quizzes and exams
//                                 </p>
//                             </div>
//                         )}
//                     </div>
//                 </div>

//                 {/* Stats Footer */}
//                 {/* {selectedCourse && (
//                     <div className="mt-8 bg-white rounded-2xl shadow-lg p-6">
//                         <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
//                             <div className="text-center">
//                                 <div className="text-3xl font-bold text-[#264b82]">{templates.length}</div>
//                                 <div className="text-gray-600">Total Templates</div>
//                             </div>
//                             <div className="text-center">
//                                 <div className="text-3xl font-bold text-[#264b82]">
//                                     {templates.filter(t => t.type === "quiz").length}
//                                 </div>
//                                 <div className="text-gray-600">Quizzes</div>
//                             </div>
//                             <div className="text-center">
//                                 <div className="text-3xl font-bold text-[#264b82]">
//                                     {templates.filter(t => t.type === "exam").length}
//                                 </div>
//                                 <div className="text-gray-600">Exams</div>
//                             </div>
//                             <div className="text-center">
//                                 <div className="text-3xl font-bold text-[#264b82]">
//                                     {templates.reduce((acc, t) => acc + t.questionCount, 0)}
//                                 </div>
//                                 <div className="text-gray-600">Total Questions</div>
//                             </div>
//                         </div>
//                     </div>
//                 )} */}
//             </div>
//         </div>
//     );
// };

// export default ExamAndQuiz;





import axiosInstance from '@/axios';
import { useEffect, useMemo, useState } from 'react';
import { toast } from 'react-toastify';

const CATEGORIES = ['Exam & Quiz', 'Webinar', 'Event', 'Newsletter', 'Survey', 'Other'];

export default function TemplateManager() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const [name, setName] = useState('');
    const [from, setFrom] = useState(CATEGORIES[0]);
    const [prompt, setPrompt] = useState('');

    const [editingId, setEditingId] = useState(null);
    const [editDraft, setEditDraft] = useState({ templateName: '', templateFrom: '', prompt: '' });

    const canCreate = useMemo(() => {
        return (name?.trim()?.length >= 2) && (prompt?.trim()?.length > 0);
    }, [name, prompt]);

    useEffect(() => { fetchAll(); }, []);

    async function fetchAll() {
        setLoading(true); setError('');
        try {
            const { data } = await axiosInstance.get('/templates/getAll');
            setItems(data.data || []);
        } catch (e) {
            setError(e.message);
        } finally { setLoading(false); }
    }

    // 🚀 NEW: AI-based generate prompt
    async function handleGenerate() {
        if (!name.trim()) {
            toast.error("Please enter a template name first!");
            return;
        }

        setLoading(true); setError('');
        try {
            const { data } = await axiosInstance.post('/templates/generate', {
                templateName: name,
                templateFrom: from
            });

            setPrompt(data.prompt || ""); // ✅ fixed
            toast.success("Prompt generated successfully!");
        } catch (e) {
            console.error(e);
            setError(e.message);
            toast.error("Failed to generate prompt");
        } finally {
            setLoading(false);
        }
    }


    async function createTemplate() {
        if (!canCreate) return;
        setLoading(true); setError('');
        try {
            const body = { templateName: name.trim(), templateFrom: from, prompt: prompt.trim() };
            const { data } = await axiosInstance.post('/templates/create', body);

            setItems(prev => [data.data, ...prev]);
            setName(''); setFrom(CATEGORIES[0]); setPrompt('');
            toast.success(data.message || "Template created successfully!");
        } catch (e) {
            setError(e.message);
        } finally { setLoading(false); }
    }

    function startEdit(item) {
        setEditingId(item.id);
        setEditDraft({ templateName: item.templateName, templateFrom: item.templateFrom, prompt: item.prompt });
    }

    function cancelEdit() {
        setEditingId(null);
        setEditDraft({ templateName: '', templateFrom: '', prompt: '' });
    }

    async function saveEdit(id) {
        setLoading(true); setError('');
        try {
            const { data } = await axiosInstance.post(`/templates/update/${id}`, editDraft);
            setItems(prev => prev.map(x => x.id === id ? data.data : x));
            cancelEdit();
            toast.success("Template updated successfully!");
        } catch (e) {
            setError(e.message);
        } finally { setLoading(false); }
    }

    async function remove(id) {
        if (!confirm('Delete this template?')) return;
        setLoading(true); setError('');
        try {
            await axiosInstance.delete(`/templates/delete/${id}`);
            setItems(prev => prev.filter(x => x.id !== id));
            toast.success("Template deleted successfully!");
        } catch (e) {
            setError(e.message);
        } finally { setLoading(false); }
    }

    return (
        <div className="min-h-screen bg-gray-50 p-6">
            <div className="mx-auto">
                <div className="mb-6">
                    <div className="dashboard-container-new !mb-5">
                        <p className="">Template Manager</p>
                    </div>
                </div>

                {/* Create Form */}
                <div className="bg-white rounded-2xl shadow p-5 mb-8">
                    <div className="grid md:grid-cols-3 gap-4">
                        <div>
                            <label className="block text-sm font-medium mb-1">Template Name</label>
                            <input
                                className="w-full rounded-xl border px-3 py-2"
                                placeholder="e.g., Midterm 2025"
                                value={name}
                                onChange={e => setName(e.target.value)}
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium mb-1">Template From</label>
                            <select
                                className="w-full rounded-xl border px-3 py-2 bg-white"
                                value={from}
                                onChange={e => setFrom(e.target.value)}
                            >
                                {CATEGORIES.map(cat => (
                                    <option key={cat} value={cat}>{cat}</option>
                                ))}
                            </select>
                        </div>
                        <div className="flex items-end">
                            <button
                                type="button"
                                onClick={handleGenerate}
                                disabled={loading}
                                className="w-full md:w-auto rounded-2xl px-4 py-2 bg-indigo-600 text-white disabled:opacity-50"
                            >
                                {loading ? "Generating…" : "Generate Prompt"}
                            </button>
                        </div>
                    </div>

                    <div className="mt-4">
                        <label className="block text-sm font-medium mb-1">Prompt</label>
                        <textarea
                            rows={5}
                            className="w-full rounded-xl border px-3 py-2"
                            placeholder="Write or generate your prompt here..."
                            value={prompt}
                            onChange={e => setPrompt(e.target.value)}
                        />
                    </div>

                    <div className="mt-4 flex gap-3">
                        <button
                            type="button"
                            disabled={!canCreate || loading}
                            onClick={createTemplate}
                            className="rounded-2xl px-4 py-2 bg-emerald-600 text-white disabled:opacity-50"
                        >
                            Save Template
                        </button>
                        <button
                            type="button"
                            onClick={() => { setName(''); setFrom(CATEGORIES[0]); setPrompt(''); }}
                            className="rounded-2xl px-4 py-2 bg-gray-200"
                        >
                            Reset
                        </button>
                    </div>
                    {error && <p className="mt-3 text-sm text-red-600">{error}</p>}
                </div>

                {/* List */}
                <div className="bg-white rounded-2xl shadow p-5">
                    <div className="flex items-center justify-between mb-3">
                        <h2 className="text-lg font-semibold">Templates</h2>
                        <button
                            onClick={fetchAll}
                            className="rounded-2xl px-3 py-2 bg-gray-100"
                        >
                            Refresh {loading ? '…' : ''}
                        </button>
                    </div>

                    <div className="overflow-x-auto">
                        <table className="min-w-full text-sm">
                            <thead>
                                <tr className="text-left text-gray-600 border-b">
                                    <th className="py-2 pr-4">ID</th>
                                    <th className="py-2 pr-4">Name</th>
                                    <th className="py-2 pr-4">From</th>
                                    <th className="py-2 pr-4">Prompt</th>
                                    <th className="py-2 pr-4">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {items.length === 0 && (
                                    <tr>
                                        <td colSpan={5} className="py-6 text-center text-gray-500">No Data Found</td>
                                    </tr>
                                )}
                                {items.map(item => (
                                    <tr key={item.id} className="border-b align-top">
                                        <td className="py-3 pr-4 text-gray-500">{item.id}</td>
                                        <td className="py-3 pr-4">
                                            {editingId === item.id ? (
                                                <input
                                                    className="w-full rounded-lg border px-3 py-2"
                                                    value={editDraft.templateName}
                                                    onChange={e => setEditDraft(d => ({ ...d, templateName: e.target.value }))}
                                                />
                                            ) : (
                                                <div className="font-medium">{item.templateName}</div>
                                            )}
                                        </td>
                                        <td className="py-3 pr-4">
                                            {editingId === item.id ? (
                                                <select
                                                    className="w-full rounded-lg border px-3 py-2 bg-white"
                                                    value={editDraft.templateFrom}
                                                    onChange={e => setEditDraft(d => ({ ...d, templateFrom: e.target.value }))}
                                                >
                                                    {CATEGORIES.map(c => <option key={c} value={c}>{c}</option>)}
                                                </select>
                                            ) : (
                                                <span className="inline-flex items-center rounded-full bg-indigo-50 text-indigo-700 px-2 py-1 text-xs">{item.templateFrom}</span>
                                            )}
                                        </td>
                                        <td className="py-3 pr-4 w-[480px]">
                                            {editingId === item.id ? (
                                                <textarea
                                                    className="w-full rounded-lg border px-3 py-2"
                                                    rows={4}
                                                    value={editDraft.prompt}
                                                    onChange={e => setEditDraft(d => ({ ...d, prompt: e.target.value }))}
                                                />
                                            ) : (
                                                <div className="text-gray-700 line-clamp-4">{item.prompt}</div>
                                            )}
                                        </td>
                                        <td className="py-3 pr-4 space-x-2 whitespace-nowrap">
                                            {editingId === item.id ? (
                                                <>
                                                    <button onClick={() => saveEdit(item.id)} className="rounded-xl px-3 py-1.5 bg-emerald-600 text-white">Save</button>
                                                    <button onClick={cancelEdit} className="rounded-xl px-3 py-1.5 bg-gray-200">Cancel</button>
                                                </>
                                            ) : (
                                                <>
                                                    <button onClick={() => startEdit(item)} className="rounded-xl px-3 py-1.5 bg-indigo-600 text-white">Edit</button>
                                                    <button onClick={() => remove(item.id)} className="rounded-xl px-3 py-1.5 bg-rose-600 text-white">Delete</button>
                                                </>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}
